import script from "./AiChatMenuButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AiChatMenuButton.vue?vue&type=script&setup=true&lang=js"

import "./AiChatMenuButton.vue?vue&type=style&index=0&id=57a5bbd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a5bbd4"]])

export default __exports__